import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

import { TooltipSize } from './Tooltip';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    tooltip: {
      fontSize: 14,
      padding: spacing(4, 3, 3, 3),
      textAlign: 'center',
      maxWidth: 250,
      backgroundColor: colors.blue.darkest,
    },
    arrow: {
      fontSize: 14,
      '&::before': {
        backgroundColor: colors.blue.darkest,
        border: `2px solid ${colors.blue.darkest}`,
      },
    },
    tooltipPlacementVertical: {},
    tooltipPlacementHorizontal: {},
    container: {
      display: 'inline',
    },
    [TooltipSize.Default]: {},
    [TooltipSize.Small]: {
      '&$tooltip': {
        padding: spacing(2, 3),
        fontSize: 12,
        fontWeight: 600,
        margin: spacing(1),
      },

      '&$tooltipPlacementVertical': {
        margin: spacing(1, 0),
      },
      '&$tooltipPlacementHorizontal': {
        margin: spacing(0, 1),
      },

      '&$arrow': {
        display: 'none',
      },
    },
  });
